export var Order;
(function (Order) {
    Order["Relevancy"] = "Default";
    Order["Recency"] = "DateDesc";
    Order["PriceAsc"] = "PriceAsc";
    Order["PriceDesc"] = "PriceDesc";
    Order["Default"] = "Default";
})(Order || (Order = {}));
